import { Outlet } from "react-router-dom";
import ParkHeightsHeader from "./ParkHeightsHeader";

const ParkHeightsLayout = () => {
    return (
        <>
            <ParkHeightsHeader/>
            <main>
                <Outlet/>
            </main>
        </>
    )
}

export default ParkHeightsLayout;